<template>
    <div class="bill-container">
        <div class="top">
            <div class="title">福利账单：</div>
            <el-input class="ipt" v-model="searchStr" placeholder="请输入员工姓名/操作人/订单编号"></el-input>
            <el-date-picker
                class="date"
                v-model="dateRange"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-button type="text" @click="searchStr='';dateRange=[];getList(1);" >重置</el-button>
            <el-button type="primary" @click="getList(1)">查询</el-button>
            <el-button type="success">导出报表</el-button>
        </div>
        <el-table :data="list">
            <el-table-column prop="orderId" label="订单编号"></el-table-column>
            <el-table-column prop="subject" label="动作"></el-table-column>
            <el-table-column prop="amount" label="福利金额(元)" :formatter="moenyFormat"></el-table-column>
            <el-table-column prop="name" label="审核人"></el-table-column>
            <el-table-column prop="createTime" label="时间">
              <template slot-scope="scope">
                {{scope.row.createTime.replace(/\-/g, "/")}}
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="备注"></el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import { getBillListById } from '@/api/welfare'
import bus from '@/utils/bus'
export default {
  data () {
    return {
      searchStr: '',
      dateRange: [],
      page: 1,
      pageSize: 10,
      companyId: '',
      list: [],
      total: 0

    }
  },
  mounted () {
    this.companyId = localStorage.companyId
    this.getList(1)
    bus.$on('changeCompany', id => {
      this.companyId = id
      this.getList(1)
    })
  },
  destroyed () {
    bus.$off('changeCompany')
  },
  methods: {
    getList (page) {
      this.page = page
      if (this.dateRange === null) this.dateRange = []
      getBillListById(this.companyId, this.searchStr, this.dateRange[0] ? this.dateRange[0] : '', this.dateRange[1] ? this.dateRange[1] : '', this.page, this.pageSize).then(res => {
        console.log(res)
        this.list = res.data.billList
        this.total = res.data.count
      })
    },
    timeFormatter (row, col) {
      return new Date(row[col.property]).toLocaleString()
    },
    moenyFormat (row, col) {
      return parseFloat(row[col.property]).toFixed(2)
    },
    pageChange (page) {
      this.getList(page)
    }
  }
}
</script>

<style lang="scss" scoped>
.bill-container{
    width: 100%;
    height: 100%;
    .top{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        .title{
            font-size: 20px;
            color: #666;
            position: absolute;
            left: 20px;
        }
        .ipt{
            width: 20%;
            margin-right: 20px;
        }
        .date{
            margin-right: 20px;
        }
    }
}

</style>
